/// <reference path="../../../../typings/index.d.ts" />


module Meevo.Plugins.YieldManagementProgram {
    angular.module("meevo.plugins.yieldManagementProgram", []);
}
